export enum EClassicPhase {
  COUNTDOWN = 'countdown',
  INITIAL = 'initial',
  PRIZES = 'prizes',
  RAFFLING = 'raffling',
  RESETTING = 'resetting',
}
